import { render, staticRenderFns } from "./Login copy.vue?vue&type=template&id=001bb514&scoped=true&"
import script from "./Login copy.vue?vue&type=script&lang=js&"
export * from "./Login copy.vue?vue&type=script&lang=js&"
import style0 from "./Login copy.vue?vue&type=style&index=0&id=001bb514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001bb514",
  null
  
)

export default component.exports